import React from 'react';
import { useNavigate } from 'react-router-dom';

const Terms = () => {
  const navigate = useNavigate();
  return (
    <div style={{background: '#000', minHeight: '100vh', color: '#ccc', padding: '40px'}}>
      <button onClick={() => navigate(-1)} style={{background: 'transparent', border: '1px solid #D4AF37', color: '#D4AF37', padding: '10px'}}>BACK</button>
      <h1 style={{color: '#fff', fontFamily: 'Orbitron', marginTop: '20px'}}>TERMS OF SERVICE</h1>
      <p>1. By entering the M.O.B. Protocol, you agree to commit to the process.</p>
      <p>2. We reserve the right to terminate access for lack of discipline.</p>
      <p>3. Your data is used to train your specific AI model.</p>
    </div>
  );
};
export default Terms;
